import Spinner from '../../../assets/Spinner.svg';
import './StoreLoader.scss';

interface Props {
    stLoading: boolean;
}

function StoreLoader({ stLoading }: Props) {

    if (!stLoading) return null;
    return (
        <div className='STLoader-container'>
            <div className='STLoader'>
                <img src={Spinner} alt='spinner' />
            </div>
        </div>
    )
}

export default StoreLoader
